<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 16px; margin-bottom: 0px"
          >
            进场公开招租申请
          </div>
        </a-space>
        <a-button
          type="primary"
          style="float: right"
          @click="createHouseResource()"
          >新建项目</a-button
        >
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="项目状态">
            <a-select
              placeholder="项目状态"
              v-model="queryParam.queryProjectStatus"
              :not-found-content="fetching.projectStatus ? undefined : null"
              @dropdownVisibleChange="projectStatusDictionaries"
              style="width: 160px"
              @change="onSearch"
            >
              <a-spin
                v-if="fetching.projectStatus"
                slot="notFoundContent"
                size="small"
              />
              <a-select-option
                v-else
                v-for="projectStatus in dictionaries.projectStatus"
                :key="projectStatus.value"
              >
                {{ projectStatus.note }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="项目名称">
            <a-input-search
              placeholder="项目名称"
              v-model="queryParam.queryProjectName"
              @search="onSearch"
              style="width: 250px"
            />
          </a-form-item>

          <a-button type="primary" style="margin-top: 4px" @click="reset"
            >重置</a-button
          >
        </a-form>
      </div>

      <a-table
        :pagination="table.pagination"
        :loading="table.loading"
        :columns="table.columns"
        :data-source="table.data"
        rowKey="webId"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      >
        <span slot="index" slot-scope="text, record, index">
          {{
            (table.pagination.pageNo - 1) * table.pagination.pageSize +
            index +
            1
          }}
        </span>

        <span slot="operation" slot-scope="text, record">
          <!-- auditStatus=1：编辑、删除 -->
          <template v-if="record.projectStatus == '编辑中'">
            <a
              @click="changeToDetail({ ...record, isEditable: true })"
              style="color: #1890ff"
              >编辑</a
            >
            <a-divider type="vertical" />
            <a @click="deleteWarrant(record)" style="color: #1890ff">删除</a>
          </template>

          <!-- auditStatus=2：仅详情 -->
          <template v-else-if="record.projectStatus === 2">
            <a
              @click="changeToDetail({ ...record, isEditable: false })"
              style="color: #1890ff"
              >详情</a
            >
          </template>

          <!-- auditStatus=3：更新、详情 -->
          <template v-else-if="record.projectStatus === 3">
            <a
              @click="changeToDetail({ ...record, isEditable: true })"
              style="color: #1890ff"
              >更新</a
            >
            <a-divider type="vertical" />
            <a
              @click="changeToDetail({ ...record, isEditable: false })"
              style="color: #1890ff"
              >详情</a
            >
          </template>

          <!-- 兜底 -->
          <template v-else>
            <a
              @click="changeToDetail({ ...record, isEditable: false })"
              style="color: #1890ff"
              >详情</a
            >
          </template>
        </span>
      </a-table>
    </a-card>

    <a-modal
      :width="1600"
      :footer="null"
      :visible="houseVisible"
      :closable="true"
      :destroyOnClose="true"
      :maskClosable="false"
      @cancel="closeMoudle"
      :zIndex="999"
    >
      <HouseResourceModal
        @closeMoudle="closeMoudle"
        @listSelectHouse="listSelectHouse"
      ></HouseResourceModal>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "项目名称",
    dataIndex: "projectName",
    width: 280,
  },
  {
    title: "项目编号",
    dataIndex: "webId",
    width: 200,
  },
  {
    title: "计租数量(租赁面积)",
    dataIndex: "rentCount",
    width: 200,
  },
  {
    title: "项目状态",
    dataIndex: "projectStatus",
    width: 280,
  },
  {
    title: "提交时间",
    dataIndex: "submitTime",
    width: 180,
  },
  {
    title: "项目负责人",
    dataIndex: "projectLeader",
    width: 200,
  },
  {
    title: "招租公告起始日期",
    dataIndex: "announcementStartDate",
    width: 200,
  },
  {
    title: "招租公告截止日期",
    dataIndex: "announcementEndDate",
    width: 200,
  },
  {
    title: "操作",
    width: 150,
    fixed: "right",
    align: "center",
    scopedSlots: { customRender: "operation" },
  },
];
import { listApplyProject, deleteApplyProject } from "@/api/project/Project.js";
import HouseResourceModal from "./HouseResourceModal";
import { scrollToTop } from "@/utils/util";
import { getBidApplyProjectType } from "@/api/shexgrp/Dictionaries.js";
export default {
  components: {
    HouseResourceModal,
  },
  props: {
    toLedgerData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fetching: {
        projectStatus: false,
      },
      dictionaries: {
        projectStatus: [
          { value: "", note: "全部", classify: "" },
          { value: "-888", note: "编辑中", classify: "" },
          { value: "-1", note: "受理退回", classify: "" },
          { value: "0", note: "录入完成", classify: "" },
          { value: "1", note: "待受理", classify: "" },
          { value: "10", note: "审核中", classify: "" },
          { value: "11", note: "已退回", classify: "" },
          { value: "12", note: "待披露", classify: "" },
          { value: "13", note: "整改中", classify: "" },
          { value: "14", note: "整改完成", classify: "" },
          { value: "19", note: "撤回发布", classify: "" },
          { value: "20", note: "已披露", classify: "" },
          { value: "30", note: "已撤牌", classify: "" },
          { value: "40", note: "已摘牌", classify: "" },
          { value: "50", note: "交易方式已选择", classify: "" },
          { value: "51", note: "成交待受理", classify: "" },
          { value: "52", note: "成交审核中", classify: "" },
          { value: "53", note: "成交受理退回", classify: "" },
          { value: "54", note: "成交退回整改", classify: "" },
          { value: "55", note: "成交整改中", classify: "" },
          { value: "56", note: "成交整改完成", classify: "" },
          { value: "57", note: "成交录入完成", classify: "" },
          { value: "60", note: "成交信息已确认", classify: "" },
          { value: "61", note: "交易凭证已打印", classify: "" },
          { value: "63", note: "交易凭证已生成", classify: "" },
          { value: "100", note: "已中止", classify: "" },
          { value: "200", note: "已终结", classify: "" },
        ],
      },
      //输入框
      queryParam: {
        projectStatus: undefined,
        projectName: undefined,
      },
      table: {
        data: [],
        loading: false,
        pagination: {
          showTotal: (total) => `共 ${total} 条`,
        },
        columns,
      },
      //权证对话框
      houseVisible: false,
    };
  },

  mounted() {
    this.queryParam.projectStatus = this.toLedgerData.queryProjectStatus;
    this.queryParam.projectName = this.toLedgerData.queryProjectName;
    this.table.pagination.current = this.toLedgerData.page;
    this.getTableDetails({
      pageSize: this.toLedgerData.pageSize,
      page: this.toLedgerData.page,
      projectStatus: this.queryParam.projectStatus,
      projectName: this.queryParam.projectName,
    });
  },

  methods: {
    //项目状态字典
    projectStatusDictionaries(visible) {
      if (!visible) return;
      // 已有数据则不再请求
      if (this.dictionaries.projectStatus.length > 0) return;
      //获取字典内容
      this.fetching.projectStatus = true;
      getBidApplyProjectType()
        .then((res) => {
          if (res && res.code === "200") {
            this.dictionaries.projectStatus = res.data || [];
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.projectStatus = false;
        });
    },

    /**
     * 分页,查询
     * 根据条件筛选并重置分页,可复制
     */
    onSearch() {
      const pager = { ...this.table.pagination };
      pager.current = 1;
      this.handleTableChange(pager);
    },

    /**
     * 分页,点击下一页
     * 表格变化回调，用于分页,筛选和排序,可复制 参数略有修改
     */
    handleTableChange(pagination) {
      //设置重置按钮分页回到第一页
      const pager = { ...this.table.pagination };
      pager.current = pagination.current;
      this.table.pagination = pager;
      this.getTableDetails({
        pageSize: this.toLedgerData.pageSize,
        page: this.toLedgerData.page,
        projectStatus: this.queryParam.projectStatus,
        projectName: this.queryParam.projectName,
      });
    },

    /**
     * 分页,默认第一页+查询
     * 获取选择层级下角色列表
     */
    getTableDetails(params = {}) {
      this.table.loading = true;
      listApplyProject({
        page: 1,
        pageSize: 10,
        ...params,
      }).then((res) => {
        const pagination = { ...this.table.pagination };
        pagination.total = res.total;
        pagination.pageSize = res.pageSize;
        pagination.pageNo = res.pageNo;
        pagination.current = res.pageNo;
        if (res.pageNo != 1 && res.data.length == 0) {
          //用于新增或删除后自动刷新，避免页面为空现象
          this.getTableDetails({
            pageSize: res.pageSize,
            page: res.pageNo - 1,
            projectStatus: this.queryParam.projectStatus,
            projectName: this.queryParam.projectName,
          });
        }
        if (res.pageNo == 1 || res.data.length != 0) {
          this.table.data = res.data;
          this.table.loading = false;
          this.table.pagination = pagination;
        }
      });
    },

    //重置表格查询
    reset() {
      //重置
      this.queryParam.projectStatus = undefined;
      this.queryParam.projectName = undefined;
      this.onSearch();
    },

    /**
     * 刷新当前页(用于新增或删除后自动刷新)
     */
    refreshCurrentPage() {
      const pager = { ...this.table.pagination };
      if (pager.current == undefined || pager.current == 1) {
        this.onSearch();
      } else {
        this.handleTableChange(pager);
      }
    },

    changeToDetail(val) {
      this.$emit("changeToDetail", {
        webId: val.webId,
        projectStatus: val.projectStatus,
        isEditable: val.isEditable,
        //选择房源列表
        selectHouseList: val.selectHouseList,
        //当前页面查询信息
        page: this.table.pagination.pageNo,
        pageSize: this.table.pagination.pageSize,
        queryProjectStatus: this.queryParam.projectStatus,
        queryProjectName: this.queryParam.projectName,
      });
      //滚动到最顶端
      scrollToTop(this);
    },

    closeMoudle() {
      this.houseVisible = false;
    },

    listSelectHouse(val) {
      this.$emit("changeToDetail", {
        webId: undefined,
        projectStatus: "-888",
        isEditable: true,
        //选择房源列表
        selectHouseList: val.selectHouseList,
        //当前页面查询信息
        page: this.table.pagination.pageNo,
        pageSize: this.table.pagination.pageSize,
        queryProjectStatus: this.queryParam.projectStatus,
        queryProjectName: this.queryParam.projectName,
      });
      this.houseVisible = false;
      //滚动到最顶端
      scrollToTop(this);
    },

    createHouseResource() {
      this.houseVisible = true;
    },

    deleteProject(record) {
      var _that = this;
      this.$confirm({
        title: "删除项目",
        content: "请确定是否删除当前项目，谨慎操作！",
        onOk() {
          deleteApplyProject({
            webId: record.webId,
          })
            .then((res) => {
              if (res.code === "200") {
                _that.$notification.success({
                  message: "删除项目",
                  description: `成功`,
                });
                _that.refreshCurrentPage();
              } else {
                _that.$notification["error"]({
                  message: "错误",
                  description: res.msg,
                });
              }
            })
            .catch((err) => {
              _that.$notification["error"]({
                message: "错误",
                description:
                  ((err.response || {}).data || {}).message ||
                  "网络异常，请稍后再试",
                duration: 4,
              });
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>